// expects strings in format YYYY-MM-DD
export function getIsFuture({ today, date }: { today: string | undefined; date: string | undefined }) {
  if (!today || !date) return false
  const [tY, tM, tD] = today.split("-").map(Number)
  const [dY, dM, dD] = date.split("-").map(Number)
  return dY > tY || (dY === tY && dM > tM) || (dY === tY && dM === tM && dD > tD)
}
